<script setup lang="ts">
import IntInput from '@components/form/int-input.vue';
import { closeLoader, openLoader } from '@utils/loader-util.js';
import apiClient from '@src/api/api-client.js';
import { addToast } from '@utils/toast-util.js';
import { PickingCartInterface } from '@src/pick/picking-cart/interface/picking-cart-interface.js';
import ButtonIcon from '@components/buttons/button-icon.vue';
import { resetPickingCartUser } from '@src/pick/picking-cart/composable/picking-cart-user-composable.js';
import VerticalAlignChildrenWrapper from '@components/layout-wrapper/vertical-align-children-wrapper.vue';
import CenterChildrenWrapper from '@components/layout-wrapper/center-children-wrapper.vue';

const emit = defineEmits<
    (event: 'pickingCartAssigned', pickingCart: PickingCartInterface|null) => void
>();

async function assignPickingCart(idBin: number) {
    openLoader();
    const pickingCart = (await apiClient.post('/be/picking-cart/assign/' + idBin)).data;
    closeLoader();
    addToast('Pickwagen erfolgreich zugeordnet');
    emit('pickingCartAssigned', pickingCart);
}

async function unassignPickingCart() {
    await resetPickingCartUser();
    addToast('Pickwagenzuordnung gelöst');
    emit('pickingCartAssigned', null);
}
</script>

<template>
    <VerticalAlignChildrenWrapper gap-top="3">
        <IntInput
            submit-button="Los"
            large
            scanner
            reuired
            @submit="assignPickingCart"
        />
        <CenterChildrenWrapper>
            <ButtonIcon icon="cart-arrow-down" @click="unassignPickingCart">Zuweisung aufheben</ButtonIcon>
        </CenterChildrenWrapper>
    </VerticalAlignChildrenWrapper>
</template>
